const MailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="19"
      viewBox="0 0 23 19"
    >
      <g
        id="Groupe_24"
        data-name="Groupe 24"
        transform="translate(-136.307 -536)"
      >
        <g
          id="Groupe_20"
          data-name="Groupe 20"
          transform="translate(136.307 536)"
        >
          <path
            id="Tracé_12"
            data-name="Tracé 12"
            d="M651.838,43.04H637.1a3.708,3.708,0,0,0-3.7,3.7V57.035a3.708,3.708,0,0,0,3.7,3.7h14.736a3.708,3.708,0,0,0,3.7-3.7V46.744a3.708,3.708,0,0,0-3.7-3.7m-3.461,8.91L654,46.065a2.256,2.256,0,0,1,.1.679V57.035a2.257,2.257,0,0,1-.1.676Zm3.461-7.472a2.253,2.253,0,0,1,1.3.41l-6.381,6.679a2.7,2.7,0,0,1-4.565,0l-6.383-6.682a2.253,2.253,0,0,1,1.3-.409Zm-16.9,13.233a2.258,2.258,0,0,1-.1-.676V46.744a2.259,2.259,0,0,1,.1-.68l5.623,5.886ZM637.1,59.3a2.252,2.252,0,0,1-1.3-.413l5.773-5.913a3.9,3.9,0,0,0,5.793,0l5.773,5.913a2.252,2.252,0,0,1-1.3.413Z"
            transform="translate(-633.398 -43.04)"
            fill="#ff5e11"
          />
        </g>
      </g>
    </svg>
  );
};

export default MailIcon;
